import React, {Component} from 'react';
import { Button, Form, Grid, Header, Icon, Modal, Segment, Label, Image, Table, Popup, Checkbox } from "semantic-ui-react";
import moment from "moment"
import * as unavailable from "../../assets/photo_unavailable.jpg";
import 'react-day-picker/lib/style.css';
import 'rc-time-picker/assets/index.css';
import CreateAgentUser from "../user/agent/create_user";
import Loader from "../universal/loader";
import AssignClerk from "./assign_clerk";
import { deleteQueryImage,uploadQueryImage,updateCustomerServiceQueryByID } from '../../data/dashboard_api';
import { DropzoneComponent } from 'react-dropzone-component';
import EditCustomerServiceItem from './edit_query_item';

class EditQueryDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            showModal: false,
            attachments: [],
            query_comment: this.props.query.query_comment,
            admin_comment: this.props.query.admin_comment,
            clerk_comment: this.props.query.clerk_comment,
            query_items:this.props.query.customer_service_items,
            conclusion_notes: this.props.query.conclusion_notes,
            emailValidated: this.props.query.email_validated,
            visibleInReport: this.props.query.visible_in_report,
            queryType: this.props.query.query_type,
            status:this.props.query.status
        };
    }

    componentWillMount() {

    }
    
    setCurrentImage = (image) => {
        this.setState({ currentImage: image, showModal: true})
    }
    handleImageSubmit = async () => {
        this.setState({ loading: true })
        let images = [...this.state.attachments]
        for (let i = 0; i < images.length; i++) {
            if (images[i].status === "queued") {
                let formData = new FormData()
                formData.append("file", images[i]);
                formData.append("query_id", this.props.query.id)
                formData.append("client_id", images[i].upload.uuid)
                formData.append("type", "general")
                await uploadQueryImage(formData);
            }}
        this.setState({ loading: false,attachments:[] });
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({isCreating:true});
        const formData = new FormData(e.target);
        formData.append("query_id", this.props.query.id);
        formData.append("visible_in_report", this.state.visibleInReport);
        formData.append("query_type", this.state.queryType);
        formData.append("status", this.state.status);
        formData.append("email_validated", this.state.emailValidated);   
        formData.append("query_items", JSON.stringify(this.state.query_items))  
        let attachmentArr = []
        this.state.attachments.map((att) =>{console.log(att);att.status == "queued"?attachmentArr.push(att.upload.uuid):null})
        formData.append("general_images",JSON.stringify(attachmentArr))
        this.updateCustomerServiceQuery(this.props.query.id,formData).then(async (response) => {
            if (response.success) {
                await this.handleImageSubmit()
            this.props.refreshData()
        }
        else {
            this.setState({showErrorInfo: true, errorMessage: response.error});
        }
        this.setState({ isCreating: false });})
    };

    updateCustomerServiceQuery = async (query_id,formData) => {
        return await updateCustomerServiceQueryByID(query_id,formData);
    };
    updateCSItem = (index,comment) => {
    let newQueryItems = [...this.state.query_items]
    newQueryItems[index].clerk_comments = comment
    this.setState({query_items:newQueryItems})
    }
    
    updateCSItemVisibility = (index,flag) => {
        let newQueryItems = [...this.state.query_items]
        newQueryItems[index].visible = flag
        this.setState({query_items:newQueryItems})
        }
    
    preloadImages = (dropzone,imageData) => {
        if (imageData) {
            for (let i = 0; i < imageData.length; i++){
            const name = imageData[i].id
            const file = {url: imageData[i].file?imageData[i].file:unavailable, name: name, size: 1000000, id: name};
            const imageUrl = imageData[i].image_path;

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);
            this.state.attachments.push(file)
            this.setState({preLoaded:true});
            dropzone.emit("addedfile", file);
            dropzone.emit("thumbnail", file, imageUrl);
                dropzone.emit("complete", file);
            }
        }
    };

    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        if (file.id) { deleteQueryImage(file.id) }
        return attachments;
    };
    successCallback = async (response) => {
        this.setState({loading:false})
    }

    render() {
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};
        let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 2000,acceptedFiles:"image/*"};
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone, this.props.query.customer_service_query_images);
            },
            addedfile: (file) => {
                this.state.attachments.push(file)
                this.setState({fileAdded:true,preLoaded:false});
            },
            removedfile: (file) => {
                this.setState({ attachments: this.removingFile(file) })          },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({maxNumberOfFilesExceeded: true});
                setTimeout(() => {
                    this.setState({maxNumberOfFilesExceeded: false})
                }, 10000)
            }
        };

        const queryTypeOptions = [
            {key: '1', text: 'Comment', value: 'comment'},
            {key: '2', text: 'Query', value: 'query'},
        ];
        const queryStatusOptions = [
            {key: '1', text: 'Pending', value: 'pending'},
            {key: '2', text: 'Awaiting Clerk Reply', value: 'awaiting_clerk_reply' },
            {key: '3', text: 'Awaiting Admin Review', value: 'awaiting_admin_review' },
            {key: '4', text: 'Closed', value: 'closed'},
        ];
        
        const emailValidOptions = [
            {key: '1', text: 'Yes', value: "true"},
            {key: '2', text: 'No', value: "false"},
        ];

        
    
        
    
        return (<React.Fragment>
            {this.state.isCreating && <Loader></Loader>}
            <Modal onClose={() => this.setState({ showModal: false })} open={this.state.showModal} size="fullscreen" style={{ height: "95%",overflow:"scroll"}}>
                <Modal.Content image style={{ height: "100%" }}>
                    <div className="modal-close-button">
                        <Button negative icon onClick={(e) => {this.setState({ showModal: false });}}>
                  <Icon name="close" />
                </Button>
              </div>
            <Image rounded centered style={{ height: this.state.zoom + "%", width: "auto",maxWidth:this.state.zoom+"%" }} src={this.state.currentImage? this.state.currentImage.image_path:null} />
            </Modal.Content>
          </Modal>
            <Segment textAlign="center">
                <Form onSubmit={this.handleSubmit}>
                <Grid stackable columns={3} className="minTop-margin left-aligned" style={{ marginTop: '0.5em' }}>
                    <Grid.Row stretched>
                            <Grid.Column width={7}>
                            <Form.Group widths={2}>
                                    <Form.Input required label='Querier Name' defaultValue={this.props.query.querier_name} icon='user' iconPosition='left' placeholder='Querier Name'
                            name="querier_name" />
                        <Form.Input required label='Querier Relation' icon='tty' iconPosition='left'
                            placeholder='Tenant, Landlord, Agent, etc'
                            type='text' name="querier_relation" defaultValue={this.props.query.querier_relation} />
                        </Form.Group>
                        <Form.Group widths={2}>
                        <Form.Input required label='Querier Email' icon='tty' iconPosition='left'
                            placeholder='abc@xyz.com'
                            type='email' defaultValue={this.props.query.validation_email} name="validation_email" />
                        <Form.Dropdown required
                            label="Submission Type"
                            selection
                            wrapSelection={false}
                            options={queryTypeOptions}
                            placeholder='Submission Type'
                            defaultValue={this.props.query.query_type}
                            onChange={(e, option) => {
                            this.setState({queryType: option.value})
                            }}/>
                                </Form.Group>
                                <Form.Group widths={2}>
                        <Form.Dropdown required
                            label="Query Status"
                            selection
                            wrapSelection={false}
                            options={queryStatusOptions}
                            placeholder='Query Status'
                            defaultValue={this.props.query.status}
                            onChange={(e, option) => {
                            this.setState({status: option.value})
                                        }} />
                        <Form.Dropdown required
                            label="Email Validated"
                            selection
                            wrapSelection={false}
                            options={emailValidOptions}
                            placeholder='Submission Type'
                            defaultValue={this.props.query.email_validated.toString()}
                            onChange={(e, option) => {
                            this.setState({emailValidated: option.value})
                            }}/>
                                </Form.Group>
                            <Form.Group widths={2}>
                                <Form.Input required type="number" label='Severity Scale' defaultValue={this.props.query.severity_points?this.props.query.severity_points:0} icon='user' iconPosition='left' placeholder='Querier Name'
                            name="severity_points" />
                            <Form.Dropdown required
                                label="Show in Report PDF"
                                selection
                                wrapSelection={false}
                                options={emailValidOptions}
                                placeholder='Show in Report PDF?'
                                defaultValue={this.props.query.visible_in_report.toString()}
                                onChange={(e, option) => {
                                this.setState({visibleInReport: option.value})
                                            }} />
                        </Form.Group>
                        </Grid.Column>
                        <Grid.Column width={9} >
                                <Segment>
                                <Form.TextArea name="query_comment" label="Query Comment"
                                        defaultValue={this.props.query.query_comment}
                                        style={{ minHeight: 180 }}
                                                           onChange={(e) => {
                                                               this.setState({
                                                                   query_comment: e.target.value,
                                                               })
                                                           }}
                                    />
                                    </Segment>
                        </Grid.Column>
                    </Grid.Row>

                    {this.props.userRole === "admin" && <Grid.Row style={{minHeight:"150px"}} stretched>
                        <Grid.Column >
                                <Segment>
                                <Form.TextArea name="clerk_comment" label="Clerk Comment"
                                        defaultValue={this.props.query.clerk_comment}
                                        style={{ minHeight: 180 }}
                                                           onChange={(e) => {
                                                               this.setState({
                                                                   clerk_comment: e.target.value,
                                                               })
                                        }} />
                                </Segment>
                        </Grid.Column>
                        <Grid.Column >
                            <Segment >
                            <Form.TextArea name="admin_comment" label="Admin Comment"
                                        defaultValue={this.props.query.admin_comment}
                                        style={{ minHeight: 180 }}
                                                           onChange={(e) => {
                                                               this.setState({
                                                                   admin_comment: e.target.value,
                                                               })
                                        }} /></Segment>
                        </Grid.Column>
                        <Grid.Column >
                            <Segment>
                            <Form.TextArea name="conclusion_notes" label="Conclusion Notes"
                                        defaultValue={this.props.query.conclusion_notes}
                                        style={{ minHeight: 180 }}
                                                           onChange={(e) => {
                                                               this.setState({
                                                                   conclusion_notes: e.target.value,
                                                               })
                                        }} /></Segment>
                        </Grid.Column>
                        </Grid.Row>}
                    <Grid.Row>
                        <Grid.Column width={16}>
                                <Segment attached>
                                    <Header>Query Photos</Header>
                      <DropzoneComponent config={componentConfig} style={{ minHeight: 250 }}
                                           eventHandlers={eventHandlers}
                                           djsConfig={djsConfig}>
                      </DropzoneComponent>
                            </Segment>
                            </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                    {this.props.query.customer_service_items.map((csItem,indexNo) => {return <EditCustomerServiceItem key={csItem.client_id} item={csItem} inspection_type={this.props.query.inspection.inspection_type} indexNo={indexNo} updateCSItem={this.updateCSItem} updateCSItemVisibility={this.updateCSItemVisibility}></EditCustomerServiceItem> })}
                    </Grid.Row>
                    </Grid>
                    <div className="submit-buttons">
                        <p></p>
                            <Button type="submit" primary content="Update Query"/>
                    </div>
                    </Form>  
            </Segment>
            </React.Fragment>);
    }
}

export default EditQueryDetail;


// WEBPACK FOOTER //
// ./src/views/inspection/edit_query_detail.js